import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error module not typed
import { getCustomContextValue } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { InfoIcon } from 'foundations-assets';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import SystemMessage from 'conversations-inbox-message-history/system-message/SystemMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomContextSystemUpdate = ({
  message
}) => {
  const customMessage = getCustomContextValue(message);
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.custom",
      options: {
        customMessage
      }
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: InfoIcon,
      size: "500"
    })
  });
};
CustomContextSystemUpdate.displayName = 'CustomContextSystemUpdate';
export default CustomContextSystemUpdate;